import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import UserAvatar from 'modules/core/components/UserAvatar'
import { getFullDisplayName } from 'modules/core/lib/userDisplayName'

import type { Participant } from 'modules/surveys/lib/participant'

interface Props {
  participant: Participant
}

export default function EmployeeLabel({ participant }: Props) {
  return (
    <Box flexDirection="row" gap="s16" alignItems="center">
      <UserAvatar
        size="s40"
        user={{ avatar: participant.avatarUrl, fullName: participant.fullName }}
      />
      <Box overflowX="hidden">
        <Text.Normal weight="medium" ellipsis>
          {getFullDisplayName({
            firstName: participant.firstName,
            lastName: participant.lastName,
          })}
        </Text.Normal>
      </Box>
    </Box>
  )
}
